import React, { createContext, useContext, useEffect, useState } from 'react';
import { usePrePopContext } from "./PrePopulationContext";

const defaultState = {
  type: 'homeseller',
  publisher_id: null,
  subid: null,
  source: process.env.REACT_APP_SOURCE,
  cake: null,
  prepop: null,
};

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [appContext, setAppContext] = useState(defaultState);
  const [isAppContextReady, setIsAppContextReady] = useState(false);
  const prePop = usePrePopContext();

  useEffect(() => {
    const getUrlParameter = (sParam) => {
      const sPageURL = decodeURIComponent(window.location.search.substring(1));
      const sURLVariables = sPageURL.split('&');
      for (let i = 0; i < sURLVariables.length; i++) {
        const sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    };

    let AffiliateID = getUrlParameter('AffiliateID');
    let PublisherID = getUrlParameter('publisher_id');
    let SubId = getUrlParameter('subid');
    let S1 = getUrlParameter('S1');
    let Cake = getUrlParameter('cake');

    const storedParams = localStorage.getItem("redirectParams");
    if (storedParams) {
      const parsedParams = JSON.parse(storedParams);
      AffiliateID = AffiliateID || parsedParams.AffiliateID;
      PublisherID = PublisherID || parsedParams.publisher_id;
      SubId = SubId || parsedParams.subid;
      S1 = S1 || parsedParams.S1;
      Cake = Cake || parsedParams.cake;

      localStorage.removeItem("redirectParams");
    }

    let newContext = { ...defaultState };

    if (AffiliateID && process.env.REACT_APP_USER_MAP) {
      process.env.REACT_APP_USER_MAP.split(',').forEach((elemMap) => {
        const [key, value] = elemMap.split('=');
        if (parseInt(key) === parseInt(AffiliateID)) {
          newContext.publisher_id = parseInt(value);
        }
      });
    } else if (PublisherID) {
      newContext.publisher_id = PublisherID;
    } else {
      newContext.publisher_id = 1;
    }

    if (S1) newContext.subid = S1;
    if (SubId) newContext.subid = SubId;
    if (Cake) newContext.cake = Cake;
    if (prePop) newContext.prepop = prePop;

    setAppContext(newContext);
    setIsAppContextReady(true);
  }, [prePop]);

  return (
    <AppContext.Provider value={{ appContext, isAppContextReady }}>
      {children}
    </AppContext.Provider>
  );
};
